import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import logo from "../assets/images/Fundswalle_Logo.png";
import landingBg from "../assets/images/landing-bg.jpg";
import MobileOtpStep1 from "../components/ApplyNowSteps/MobileOtpStep1";
import ApplyLoanDigitapIdentityStep1 from "../components/ApplyNowSteps/ApplyLoanDigitapIdentityStep1";
import LandingLoanForm from "../components/ApplyNowSteps/LandingLoanForm";
import ThankYou1 from "../components/ApplyNowSteps/ThankYou1";
import {
  clearLoanStepDraft,
  clearStep2ContactRestore,
} from "../utils/applyFlowStorage";
import {
  markApplyLoanActive,
  resolveApplyLoanResumeStep,
  restoreApplyLoanSecureFields,
  saveApplyLoanDigitapCallbackTxn,
  saveApplyLoanDigitapDraft,
  getApplyLoanDigitapDraft,
  saveApplyLoanStep,
} from "../utils/applyLoanStorage";
import { seedApplyLoanProfileFromAadhaar } from "../utils/seedApplyLoanProfile";
import {
  clearApplyLoanDigitapReturnParams,
  handoffDigitapCallbackToOpenerIfNeeded,
  readApplyLoanDigitapReturnParams,
} from "../utils/digitapKycUtils";
import "../pages/ApplyNow.css";
import "../pages/ApplyNow1.css";
import "./InstantLoanLanding.css";

const LANDING_SOURCE = "landing";
/** Exact Fundswalla landing DigiLocker start */
const LANDING_DIGITAP_SEND_URL =
  "https://fundswalla.in/loan_backend/sendAadhaarOtpla.php";

const LANDING_STEPS = [
  { id: 1, label: "Mobile OTP" },
  { id: 2, label: "PAN & DigiLocker" },
  { id: 3, label: "Loan Details" },
];

const LandingStepPills = ({ currentStep }) => (
  <div className="fw-landing__progress" aria-label="Application progress">
    <div className="fw-landing__progress-track">
      <span
        className="fw-landing__progress-fill"
        style={{ width: `${((currentStep - 1) / (LANDING_STEPS.length - 1)) * 100}%` }}
      />
    </div>
    <div className="fw-landing__steps">
      {LANDING_STEPS.map((item) => (
        <div
          key={item.id}
          className={`fw-landing__step ${
            currentStep === item.id
              ? "is-active"
              : currentStep > item.id
                ? "is-done"
                : ""
          }`}
        >
          <span className="fw-landing__step-dot">
            {currentStep > item.id ? "✓" : item.id}
          </span>
          <span className="fw-landing__step-label">{item.label}</span>
        </div>
      ))}
    </div>
  </div>
);

const LandingBackdrop = () => (
  <>
    <div className="fw-landing__bg" aria-hidden="true">
      <img
        className="fw-landing__bg-img"
        src={landingBg}
        alt=""
        loading="eager"
        decoding="async"
        fetchPriority="high"
      />
    </div>
    <div className="fw-landing__overlay" aria-hidden="true" />
  </>
);

const SIDE_POINTS = [
  "100% online — no branch visit",
  "Quick digital verification",
  "Secure & encrypted application",
  "For salaried professionals only",
];

const SIDE_STATS = [
  { value: "Paperless", label: "Zero branch visit needed" },
  { value: "Fast Track", label: "Apply in a few minutes" },
  { value: "Secure", label: "Encrypted end-to-end" },
];

const LandingSideCopy = () => (
  <aside className="fw-landing__side">
    <span className="fw-landing__side-badge">RBI Registered NBFC</span>
    <h1 className="fw-landing__side-title">
      Instant Personal Loan
      <span>when you need it most</span>
    </h1>
    <p className="fw-landing__side-text">
      Apply in 3 easy steps — verify mobile, confirm identity via DigiLocker,
      and submit your loan details. Fast, paperless, and secure.
    </p>

    <ul className="fw-landing__side-list">
      {SIDE_POINTS.map((point) => (
        <li key={point}>
          <FiCheckCircle aria-hidden="true" />
          <span>{point}</span>
        </li>
      ))}
    </ul>

    <div className="fw-landing__side-stats">
      {SIDE_STATS.map((item) => (
        <div key={item.value} className="fw-landing__side-stat">
          <strong>{item.value}</strong>
          <small>{item.label}</small>
        </div>
      ))}
    </div>
  </aside>
);

const LandingFormCard = ({
  step,
  onMobileNext,
  onIdentityNext,
  onBack,
  onSubmitSuccess,
}) => (
  <div
    className={`fw-landing__form-card ${
      step === 3 ? "fw-landing__form-card--loan" : ""
    }`}
  >
    <div className="fw-landing__form-head">
      <div className="fw-landing__form-head-top">
        <div>
          <h2>Apply Now</h2>
          <p>Complete in 3 simple steps</p>
        </div>
      </div>
      <LandingStepPills currentStep={step} />
    </div>

    <div
      className={`fw-landing__step-body apply-now1-page ${
        step === 3 ? "fw-landing__step-body--loan" : ""
      }`}
    >
      {step === 1 && (
        <div className="apply-now1-stage apply-now1-stage--focus apply-loan-stage--mobile">
          <MobileOtpStep1
            hideHero
            enquirySource={LANDING_SOURCE}
            onNext={onMobileNext}
          />
        </div>
      )}

      {step === 2 && (
        <div className="apply-now1-stage apply-now1-stage--focus apply-loan-stage--mobile">
          <ApplyLoanDigitapIdentityStep1
            hideHero
            enquirySource={LANDING_SOURCE}
            sendKycUrl={LANDING_DIGITAP_SEND_URL}
            onNext={onIdentityNext}
          />
        </div>
      )}

      {step === 3 && (
        <div className="apply-now1-stage-card apply-now1-stage-card--scroll fw-landing__loan-stage">
          <LandingLoanForm
            leadSource={LANDING_SOURCE}
            onBack={onBack}
            onNext={onSubmitSuccess}
          />
        </div>
      )}
    </div>

    <p className="fw-landing__form-trust">
      Your data is encrypted &amp; never shared without consent
    </p>
  </div>
);

/**
 * /landing — DigiLocker identity (same as /apply-loan) + LandingLoanForm fields.
 * Lead source always "landing". /apply-now OTP and /apply-loan LoanForm1 untouched.
 */
const InstantLoanLanding = () => {
  const [step, setStep] = useState(() => resolveApplyLoanResumeStep());
  const [ready, setReady] = useState(false);
  const [popupHandoff, setPopupHandoff] = useState(false);

  useEffect(() => {
    // DigiLocker redirected into this popup → return to original form tab
    if (handoffDigitapCallbackToOpenerIfNeeded()) {
      setPopupHandoff(true);
      return;
    }

    markApplyLoanActive();
    restoreApplyLoanSecureFields();
    // Do not flush saveEnquiry on mount — same as /apply-loan.
    // Step components + unload autosave already save with source "landing".
    // Mount flush was double-hitting with MobileOtpStep1 / LandingLoanForm autosave.

    // DigiLocker callback may land on this tab — capture txn BEFORE scrubbing
    const cb = readApplyLoanDigitapReturnParams();
    if (cb.txnId) {
      saveApplyLoanDigitapCallbackTxn(cb.txnId);
      const existing = getApplyLoanDigitapDraft();
      saveApplyLoanDigitapDraft({
        pan: existing?.pan || "",
        transactionId: cb.txnId,
        kycUrl: existing?.kycUrl || "",
        startedAt: existing?.startedAt || Date.now(),
        mobileVerified: true,
        panVerified: true,
      });
      clearApplyLoanDigitapReturnParams();
    }

    let resume = resolveApplyLoanResumeStep();
    const pending = getApplyLoanDigitapDraft();
    if (
      resume < 3 &&
      (cb.txnId || pending?.transactionId) &&
      localStorage.getItem("mobile_verified") === "true"
    ) {
      resume = 2;
    }
    if (resume === 3) {
      seedApplyLoanProfileFromAadhaar();
    }
    setStep(resume);
    saveApplyLoanStep(resume);
    setReady(true);
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflowX;
    const prevBodyOverflow = body.style.overflowX;

    html.style.overflowX = "hidden";
    body.style.overflowX = "hidden";

    return () => {
      html.style.overflowX = prevHtmlOverflow;
      body.style.overflowX = prevBodyOverflow;
    };
  }, []);

  const goToStep = (next) => {
    const n = Number(next);
    setStep(n);
    saveApplyLoanStep(n);
  };

  const handleEnterIdentityFromMobile = () => {
    // saveEnquiry already flushed in MobileOtpStep1.verifyOtp — do not double-hit
    clearStep2ContactRestore();
    clearLoanStepDraft();
    goToStep(2);
  };

  const handleEnterLoanFromIdentity = () => {
    // saveEnquiry already flushed in DigiLocker finalize — do not double-hit
    clearStep2ContactRestore();
    seedApplyLoanProfileFromAadhaar();
    clearLoanStepDraft();
    goToStep(3);
  };

  const handleBackToIdentity = () => {
    goToStep(2);
  };

  const handleSubmitSuccess = () => {
    goToStep(4);
  };

  if (popupHandoff) {
    return (
      <div className="fw-landing fw-landing-page apply-loan-page">
        <div className="fw-landing__shell" style={{ paddingTop: 48, textAlign: "center" }}>
          <p style={{ color: "#fff", fontSize: "0.95rem" }}>
            Aadhaar verified. Returning to your application…
          </p>
          <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.8rem", marginTop: 8 }}>
            If this tab stays open, close it and switch back to your original form tab.
          </p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return null;
  }

  if (step === 4) {
    return (
      <div className="fw-landing fw-landing-page apply-loan-page">
        <LandingBackdrop />
        <div className="fw-landing__shell fw-landing__shell--success">
          <header className="fw-landing__header">
            <Link to="/" className="fw-landing__logo">
              <img src={logo} alt="Fundswalle" />
            </Link>
          </header>
          <div className="fw-landing__layout fw-landing__layout--success">
            <div className="fw-landing__form-panel">
              <div className="fw-landing__form-card fw-landing__success-card">
                <ThankYou1 />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fw-landing fw-landing-page apply-loan-page">
      <LandingBackdrop />

      <div className="fw-landing__shell">
        <header className="fw-landing__header">
          <Link to="/" className="fw-landing__logo">
            <img src={logo} alt="Fundswalle" />
          </Link>
        </header>

        <div
          className={`fw-landing__layout ${
            step === 3 ? "fw-landing__layout--loan" : ""
          }`}
        >
          <LandingSideCopy />

          <div className="fw-landing__form-panel">
            <LandingFormCard
              step={step}
              onMobileNext={handleEnterIdentityFromMobile}
              onIdentityNext={handleEnterLoanFromIdentity}
              onBack={handleBackToIdentity}
              onSubmitSuccess={handleSubmitSuccess}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstantLoanLanding;
